export default function GlobalStyles() {
  return (
    <style>{`
      @keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
      .animate-fade-in-up { animation: fadeInUp 1s cubic-bezier(0.2, 0.8, 0.2, 1) forwards; }

      @keyframes fadeInDown { from { opacity: 0; transform: translateY(-20px); } to { opacity: 1; transform: translateY(0); } }
      .animate-fade-in-down { animation: fadeInDown 1s ease-out forwards; }

      @keyframes scaleIn { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }
      .animate-scale-in { animation: scaleIn 1.2s cubic-bezier(0.2, 0.8, 0.2, 1) forwards; }

      @keyframes slowScale { 0% { transform: scale(1); } 100% { transform: scale(1.15); } }
      .animate-slow-scale { animation: slowScale 25s linear infinite alternate; }
    `}</style>
  );
}
